import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import User from "./User";

const UserDetail = () => {
  document.title = "User Detail";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="User Detail" />
          <User />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserDetail;
